import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useSelector, useDispatch } from "react-redux";
import {
    logout,
    setName,
    setLastName,
    setProfile,
    setRole,
    setUserId,
    setEmail,
    setUser,
    setTeamName,
} from "../../store/actions/authActions";
import { ReactComponent as Line } from "../../utils/assets/line.svg";
import { ReactComponent as OxiwearLogo } from "../../utils/assets/oxiwear_logo.svg";
import { ReactComponent as Selector } from "../../utils/assets/selector.svg";
import styles from "./layout.module.css";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Fade from "@mui/material/Fade";
import Avatar from "@mui/material/Avatar";
import AddUser from "../../components/UI/addUser/AddUser";
import { ReactComponent as PersonAddAltIcon } from "../../utils/assets/add users.svg";
import { ReactComponent as PersonOutlineIcon } from "../../utils/assets/profile_account.svg";
import { ReactComponent as SortIcon } from "../../utils/assets/profile_admin_management.svg";
import { ReactComponent as SendOutlinedIcon } from "../../utils/assets/profile_support.svg";
import { ReactComponent as LogoutOutlinedIcon } from "../../utils/assets/profile_logout.svg";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";

import { makeStyles } from "@material-ui/core/styles";
import LogOutModel from "./logOutModal";
import SupportModal from "./supportModal";
import AccountModal from "../../screens/settings/accountModal";
import ChnagePasswordModal from "../../screens/settings/changePassword/changePasswordModal";
import EmailChangeModal from "../../screens/settings/changeEmail/changeEmailModal";
import SuccessModal from "../../screens/settings/changePassword/successModal";
import SuccessEmailModal from "../../screens/settings/changeEmail/successEmailModal";
import NotificationModal from "../../screens/notification/notificationModal";
import AuthenticationModal from "../../screens/settings/authenticationFlow/authenticationModal";
import CoachManagementModal from "../../screens/settings/coachManagement/coachManagementModal";
import AuthenticationBeforeModal from "../../screens/settings/authenticationFlow/authenticationBeforeModal";
import SuccessEmailModalForAdmin from "../../screens/settings/changeEmail/successEmailModalForAdmin";
import SubscriptionMainModal from "../../screens/subscription/subscriptionmain";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
    menu: {
        "& .MuiPaper-root": {
            backgroundColor: "#313131",
            color: "#DADADA",
            borderRadius: 0,
            boxShadow: "none",
            minWidth: 198,
        },
        "& .MuiMenuItem-root": {
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: 400,
            padding: "10px",
            gap: "2px",
            justifyContent: "flex-start",
            transition: "background-color 225ms ease, opacity 225ms ease",
        },
        "& .MuiMenuItem-root:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            fontWeight: 500,
            color: "#FFFFFF",
        },
        "& .MuiListItemIcon-root": {
            minWidth: "auto",
            marginRight: 0,
            color: "inherit",
        },
    },
}));

export default function ButtonAppBar() {
    let navigate = useNavigate();
    const axiosInstance = useAxiosPrivate();
    const classes = useStyles();
    const state = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const [openedAuthentication, setOpenAuthentication] = useState(false);
    const [openedAuthenticationBefore, setOpenAuthenticationBefore] =
        useState(false);
    const [openedSupport, setOpenedSupport] = useState(false);
    const [openedAccount, setOpenedAccount] = useState(false);
    const [openedPassword, setOpenedPassword] = useState(false);
    const [openedEmail, setOpenedEmail] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successEmail, setSuccessEmail] = useState(false);
    const [coachManagement, setCoachManagement] = useState(false);
    const [imageURL, setImageURL] = useState("");
    const [verificationID, setVerificationID] = useState("");
    const [successEmailForAdmin, setSuccessEmailForAdmin] = useState(false);
    const [openSubscriptionMainModal, setOpenSubscriptionMainModal] =
        useState(false);
    let urlElements = window.location.href.split("/");
    const [profileLoaded, setProfileLoaded] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        window.location.href = "/";
    };

    const playerDirect = () => {
        navigate("/patients");
    };
    const DashDirect = () => {
        navigate("/dashboard");
    };

    const UserDirect = () => {
        navigate("/users");
    };

    const TeamDirect = () => {
        navigate("/team");
    };

    const ReportDirect = () => {
        navigate("/reports");
    };

    const appBarRef = React.useRef(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorPosition, setAnchorPosition] = React.useState({
        top: 0,
        left: 0,
    });
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        const appBarBottom =
            appBarRef.current?.getBoundingClientRect().bottom ?? 0;
        setAnchorPosition({ top: appBarBottom, left: window.innerWidth });
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // Set domain image URL (runs once on mount since domainUrl is constant)
    useEffect(() => {
        const domainURLs = [
            "lnpc.oxiwear.fitness",
            "dev-lnpc.oxiwear.fitness",
            "msc.oxiwear.fitness",
            "sju.oxiwear.fitness",
            "jhu.oxiwear.fitness",
            "cch.oxiwear.com",
            "sayf.oxiwear.com",
            "teams.oxiwear.fitness",
            "medical-teams.oxiwear.com",
            "teams.oxiwear.com",
            "jhu.oxiwear.com",
        ];

        const currentDomain = window.location.hostname;
        //console.log('currentDomain', currentDomain);
        if (domainURLs.includes(currentDomain)) {
            setImageURL(currentDomain.split(".")[0]);
        } else {
            // setImageURL('dev');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const loadProfile = async () => {
            if (profileLoaded) return;

            const token =
                state.accessToken || sessionStorage.getItem("accessToken");
            if (!token) {
                console.warn("No access token, skipping profile load.");
                return;
            }

            if (!state.name || !state.email || !state.role) {
                const { data } = await axiosInstance.get("/user/profile");
                const profileData = data.data;

                dispatch(setUser(profileData));
                dispatch(setName(profileData.first_name));
                dispatch(setLastName(profileData.last_name));
                dispatch(setRole(profileData.role));
                dispatch(setProfile(profileData.avatar_url));
                dispatch(setUserId(profileData.id));
                dispatch(setEmail(profileData.email));
                dispatch(setTeamName(profileData.team?.name));
            }

            setProfileLoaded(true); // Mark profile as loaded
        };

        loadProfile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.accessToken]);

    return (
        <Box sx={{ flexGrow: 1 }}>
            {state.accessToken &&
            urlElements[urlElements.length - 1] !== "profile" &&
            urlElements[urlElements.length - 2] !== "register" ? (
                <AppBar
                    ref={appBarRef}
                    position="fixed"
                    style={{
                        backgroundColor:
                            imageURL === "msc" ? "#4689e0" : "#313131",
                        height: "3.37rem",
                    }}
                >
                    <Toolbar
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0 3.43rem",
                            cursor: "pointer",
                            position: "relative",
                            backgroundColor:
                                "var(--primary-popup-background-color)",
                        }}
                    >
                        <div
                            style={{ display: "flex", alignItems: "center" }}
                            onClick={DashDirect}
                        >
                            <OxiwearLogo />
                            <Line
                                style={{
                                    width: 40,
                                    height: 20,
                                }}
                            />
                            <p
                                style={{
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "20px",
                                    lineHeight: "30px",
                                    color: "#D8EBEC",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {state.teamName}
                            </p>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                position: "absolute",
                                left: "50%",
                                transform: "translateX(-50%)",
                            }}
                        >
                            <p
                                className={
                                    urlElements[urlElements.length - 1] ===
                                    "dashboard"
                                        ? styles.para3
                                        : styles.para
                                }
                                onClick={DashDirect}
                            >
                                Dashboard
                            </p>
                            <p
                                className={
                                    urlElements[urlElements.length - 1] ===
                                    "team"
                                        ? styles.para3
                                        : styles.para
                                }
                                onClick={TeamDirect}
                            >
                                Team
                            </p>
                            <p
                                className={
                                    urlElements[urlElements.length - 1] ===
                                    "patients"
                                        ? styles.para3
                                        : styles.para
                                }
                                onClick={playerDirect}
                            >
                                Players
                            </p>
                            {state?.role !== "USER" ? (
                                <p
                                    className={
                                        urlElements[
                                            urlElements.length - 1
                                        ] === "reports"
                                            ? styles.para3
                                            : styles.para
                                    }
                                    onClick={ReportDirect}
                                >
                                    Report
                                </p>
                            ) : null}
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <PersonAddAltIcon
                                onClick={UserDirect}
                                style={{ margin: "0px 1.5rem" }}
                            />
                            <AddUser style={{ margin: "0px 1.5rem" }} />
                            {/* <AddDevice/> */}
                            <NotificationModal
                                setOpenAuthentication={
                                    setOpenAuthenticationBefore
                                }
                                setOpenedAccount={setOpenedAccount}
                            />
                            <div
                                className={styles.profileTrigger}
                                onClick={handleClick}
                            >
                                <Avatar
                                    alt={state.name}
                                    src={state.url}
                                    sx={{ width: 25, height: 25 }}
                                />
                                <p
                                    className={
                                        open ? styles.para2Active : styles.para2
                                    }
                                >
                                    {state.name}
                                </p>
                                <Selector
                                    className={
                                        open
                                            ? styles.profileSelectorOpen
                                            : styles.profileSelector
                                    }
                                />
                            </div>
                            <>
                                <Menu
                                    id="fade-menu"
                                    MenuListProps={{
                                        "aria-labelledby": "fade-button",
                                    }}
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                    TransitionComponent={Fade}
                                    className={classes.menu}
                                    anchorReference="anchorPosition"
                                    anchorPosition={anchorPosition}
                                    marginThreshold={0}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "stretch",
                                        }}
                                        onClick={() => handleClose()}
                                    >
                                        <MenuItem
                                            onClick={() =>
                                                setOpenedAccount(true)
                                            }
                                        >
                                            <ListItemIcon>
                                                <PersonOutlineIcon
                                                    className={
                                                        styles.profileMenuIcon
                                                    }
                                                />
                                            </ListItemIcon>
                                            Account
                                        </MenuItem>
                                        {state?.role !== "COACH" ? (
                                            <MenuItem
                                                onClick={() =>
                                                    setCoachManagement(true)
                                                }
                                            >
                                                <ListItemIcon>
                                                    <SortIcon
                                                        className={
                                                            styles.profileMenuIcon
                                                        }
                                                    />
                                                </ListItemIcon>
                                                Team Staff Management
                                            </MenuItem>
                                        ) : null}
                                        {/* {imageURL !== "sju" && (
                      <MenuItem
                        onClick={() => setOpenSubscriptionMainModal(true)}
                      >
                        Subscription
                      </MenuItem>
                    )} */}
                                        <MenuItem
                                            onClick={() =>
                                                setOpenedSupport(true)
                                            }
                                        >
                                            <ListItemIcon>
                                                <SendOutlinedIcon
                                                    className={
                                                        styles.profileMenuIcon
                                                    }
                                                />
                                            </ListItemIcon>
                                            Support
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => setOpened(true)}
                                        >
                                            <ListItemIcon>
                                                <LogoutOutlinedIcon
                                                    className={
                                                        styles.profileMenuIcon
                                                    }
                                                />
                                            </ListItemIcon>
                                            Logout
                                        </MenuItem>
                                    </div>
                                </Menu>
                            </>
                            <LogOutModel
                                setOpen={setOpened}
                                open={opened}
                                handleLogout={handleLogout}
                            />
                            <SupportModal
                                setOpen={setOpenedSupport}
                                open={openedSupport}
                            />
                            <AccountModal
                                setOpen={setOpenedAccount}
                                open={openedAccount}
                                setOpenedPassword={setOpenedPassword}
                                setOpenAuthentication={setOpenAuthentication}
                            />
                            <ChnagePasswordModal
                                setOpen={setOpenedPassword}
                                open={openedPassword}
                                setOpenedAccount={setOpenedAccount}
                                setSuccess={setSuccess}
                            />
                            <SuccessModal
                                setOpen={setSuccess}
                                open={success}
                                setOpenedPassword={setOpenedPassword}
                            />
                            <EmailChangeModal
                                setOpen={setOpenedEmail}
                                open={openedEmail}
                                setOpenAuthentication={setOpenAuthentication}
                                setSuccessEmail={setSuccessEmail}
                                verificationID={verificationID}
                                setOpenAuthenticationBefore={
                                    setOpenAuthenticationBefore
                                }
                            />
                            <SuccessEmailModal
                                setOpen={setSuccessEmail}
                                open={successEmail}
                                setOpenedEmail={setOpenedEmail}
                            />
                            <AuthenticationModal
                                setOpen={setOpenAuthentication}
                                open={openedAuthentication}
                                setOpenedAccount={setOpenedAccount}
                                setOpenedEmail={setOpenedEmail}
                                setVerificationID={setVerificationID}
                            />

                            <CoachManagementModal
                                setOpen={setCoachManagement}
                                open={coachManagement}
                            />
                            <AuthenticationBeforeModal
                                setOpen={setOpenAuthenticationBefore}
                                open={openedAuthenticationBefore}
                                setSuccessEmailForAdmin={
                                    setSuccessEmailForAdmin
                                }
                                setOpenedEmail={setOpenedEmail}
                            />
                            <SuccessEmailModalForAdmin
                                setOpen={setSuccessEmailForAdmin}
                                open={successEmailForAdmin}
                                setOpenAuthenticationBefore={
                                    setOpenAuthenticationBefore
                                }
                            />
                            <SubscriptionMainModal
                                setOpen={setOpenSubscriptionMainModal}
                                open={openSubscriptionMainModal}
                            />
                        </div>
                    </Toolbar>
                </AppBar>
            ) : null}
        </Box>
    );
}
